export const GET_CARD_HOLDER = 'GET_CARD_HOLDER';
export type GET_CARD_HOLDER = typeof GET_CARD_HOLDER;

export const SET_CARD_HOLDER = 'SET_CARD_HOLDER';
export type SET_CARD_HOLDER = typeof SET_CARD_HOLDER;
